module.exports = "/static/media/howToImage1.e29296af.jpg";